import { AbstractTracker } from '../../../internal/platformMetrics/aggregators/AbstractTracker';
class CounterWithAreaCount extends AbstractTracker {
    track(id, areaId, poject) {
        var _this_data, _id, _this_data_id;
        var _;
        (_ = (_this_data = this.data)[_id = id]) !== null && _ !== void 0 ? _ : _this_data[_id] = Object.create(null);
        var _count;
        (_count = (_this_data_id = this.data[id]).count) !== null && _count !== void 0 ? _count : _this_data_id.count = 0;
        this.data[id].count++;
        var _this_data_id_areaData;
        // extract the data for this id, defaulting to an empty object
        const areaData = (_this_data_id_areaData = this.data[id].areaData) !== null && _this_data_id_areaData !== void 0 ? _this_data_id_areaData : Object.create(null);
        var _areaData_areaId;
        // extract the areadData for this area, defaulting to an empty object
        const dataForId = (_areaData_areaId = areaData[areaId]) !== null && _areaData_areaId !== void 0 ? _areaData_areaId : Object.create(null);
        var _dataForId_poject;
        // extract the count for this poject, defaulting to 0
        const count = (_dataForId_poject = dataForId[poject]) !== null && _dataForId_poject !== void 0 ? _dataForId_poject : 0;
        // reassign to the count, incremented by 1
        dataForId[poject] = count + 1;
        // reassign to the areaData, with the new data
        areaData[areaId] = dataForId;
        // reassign to the data, with the new areaData
        this.data[id].areaData = areaData;
    }
}
export { CounterWithAreaCount as default };

//# sourceMappingURL=CounterWithAreaCount.js.map